var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block subscriptions"},[_c('subscriptions',{attrs:{"loading":_vm.store.isFetching.subscriptions,"subscribed":_vm.store.subscribed},on:{"toggleSubscription":_vm.onToggleSubscription}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }